var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup320(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "#E69A8D",
    stroke: "#E69A8D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0667 22.6663C37.3691 22.9204 38.5659 23.5574 39.5042 24.4956C40.4424 25.4338 41.0793 26.6307 41.3334 27.933M36.0667 17.333C38.7724 17.6336 41.2955 18.8452 43.2217 20.769C45.1479 22.6928 46.3628 25.2144 46.6667 27.9197M45.3334 38.5597V42.5597C45.3349 42.931 45.2589 43.2986 45.1101 43.6388C44.9613 43.979 44.7431 44.2845 44.4695 44.5355C44.1959 44.7865 43.8728 44.9777 43.5211 45.0966C43.1693 45.2156 42.7966 45.2598 42.4267 45.2263C38.3239 44.7805 34.3827 43.3785 30.9201 41.133C27.6985 39.0859 24.9672 36.3546 22.9201 33.133C20.6667 29.6546 19.2644 25.6943 18.8267 21.573C18.7934 21.2043 18.8372 20.8327 18.9554 20.4818C19.0736 20.131 19.2635 19.8086 19.5131 19.5352C19.7627 19.2617 20.0665 19.0433 20.4051 18.8937C20.7438 18.7441 21.1099 18.6667 21.4801 18.6663H25.4801C26.1271 18.66 26.7545 18.8891 27.2451 19.3111C27.7357 19.733 28.0562 20.3189 28.1467 20.9597C28.3156 22.2398 28.6287 23.4966 29.0801 24.7063C29.2595 25.1836 29.2983 25.7022 29.1919 26.2008C29.0856 26.6995 28.8386 27.1572 28.4801 27.5197L26.7867 29.213C28.6848 32.5511 31.4487 35.3149 34.7867 37.213L36.4801 35.5197C36.8426 35.1612 37.3003 34.9141 37.7989 34.8078C38.2975 34.7015 38.8162 34.7403 39.2934 34.9197C40.5031 35.3711 41.76 35.6842 43.0401 35.853C43.6878 35.9444 44.2793 36.2706 44.7021 36.7697C45.125 37.2687 45.3496 37.9058 45.3334 38.5597Z",
    fill: "#7A51AE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup320);
export default __webpack_public_path__ + "static/media/Group320.d8f454664de35725b6676b13d0ebc796.svg";
export { ForwardRef as ReactComponent };